export enum LocalStorageList {
  currentUser = 'currentUser',
  token = 'token',
  expiration = 'expiration',
  name = 'name',
  refresh_token = 'refresh_token',
  portInToken = 'portInToken',
  suspended = 'suspended',
  orderData = 'orderData',
}
